/* product.js */
'use strict';

$(function() {

// multiModal

var $multiModal = $('#multiModal');
var modalRedirectUrl;
$multiModal.on('show.bs.modal', function(e) {
  var triggeredBy = e.relatedTarget;
  modalRedirectUrl = (triggeredBy) ? triggeredBy.dataset.url : '';
  // console.info('#multiModal url = %s', modalRedirectUrl);
});
$('.clickRedirect').on('click', function() {
  $multiModal.modal('hide');
  if (modalRedirectUrl) {
    window.location.href = modalRedirectUrl;
  }
});

// tooltips (REMOVED for testing 10112021 DM)
// $('[data-tooltip=\'true\']').tooltip({
//   container: 'body'
// });

});

// ACCORDION SCROLL-TO-TOP SCRIPT 
// This function scrolls to the top of opened accordion drawers' panels, preventing newly opened .pane; objects from scrolling out of view through the top of the viewport
function panelScroll(){
  $('.accParent').on('shown.bs.collapse', function(){
    // define width of the window as variable (for later use in mobile viewports)
    var winW = $(window).width();
    // define nearest panel object in the DOM (this is the .panel that is about to be clicked open into display)
    var $panel = $(this).closest('.panel.panel-default.panel-outer');
    // define scroll-offset: adjust height px value to account for content at top of panel (including masthead/title-bar if they exist)
    var offsetPX = -124; // set to height of desktop header; when set to zero ('0'), the offset will animate the opened accordion .panel div to the top of the viewport
    // logic for changing offset value in mobile display if necessary due to height of page elements in mobile rendering
    if(winW <= 767){
        var offsetPX = 0; // set to height of mobile header; when set to zero ('0'), the offset will animate the opened accordion .panel div flush to the top of the viewport
    }
    // animate the scroll behavior to height of offset pixel value, duration 1s
    $('html,body').animate({
      scrollTop: $panel.offset().top + offsetPX
    }, 250); 
  });   
  // prevent event capturing (DOWN through the DOM) from parent accordion to nested children accordions
  $('.accChild').on('shown.bs.collapse', function(e){            
      e.stopPropagation();                      
  });
};
function cardScroll(){
  $('.accParent').on('shown.bs.collapse', function(){
    // define width of the window as variable (for later use in mobile viewports)
    var winW = $(window).width();
    // define nearest panel object in the DOM (this is the .panel that is about to be clicked open into display)
    var $card = $(this).closest('.card');
    // define scroll-offset: adjust height px value to account for content at top of panel (including masthead/title-bar if they exist)
    var offsetPX = -60; // set to height of desktop header; when set to zero ('0'), the offset will animate the opened accordion .panel div to the top of the viewport
    // logic for changing offset value in mobile display if necessary due to height of page elements in mobile rendering
    if(winW <= 767){
        var offsetPX = 0; // set to height of mobile header; when set to zero ('0'), the offset will animate the opened accordion .panel div flush to the top of the viewport
    }
    // animate the scroll behavior to height of offset pixel value, duration 1s
    $('html,body').animate({
      scrollTop: $card.offset().top + offsetPX
    }, 250); 
  });   
  // prevent event capturing (DOWN through the DOM) from parent accordion to nested children accordions
  $('.accChild').on('shown.bs.collapse', function(e){            
      e.stopPropagation();                      
  });
};